const SALT = "I33_SECRET_SALT"

export const cipher = (salt: string) => {
  const textToChars = (text: string) => text.split('').map((c: string) => c.charCodeAt(0));
  const byteHex = (n: string) => ("0" + Number(n).toString(16)).substr(-2);
  const applySaltToChar = (code: any) => textToChars(salt).reduce((a,b) => a ^ b, code);

  return (text: string) => text.split('')
      .map(textToChars)
      .map(applySaltToChar)
      .map(byteHex)
      .join('');
}

const decipher = (salt: string) => {
  const textToChars = (text: string) => text.split('').map((c: string) => c.charCodeAt(0));
  const applySaltToChar = (code: any) => textToChars(salt).reduce((a: number,b: number) => a ^ b, code);
  return (encoded: { match: (arg0: RegExp) => any[]; }) => encoded.match(/.{1,2}/g)
      .map((hex: string) => parseInt(hex, 16))
      .map(applySaltToChar)
      .map((charCode: number) => String.fromCharCode(charCode))
      .join('');
}

export const encryption = cipher(SALT);
export const decryption = decipher(SALT);

